export default "__VITE_ASSET__BGrdlV1x__"